<template>
  <div class="pa-5">
    <v-skeleton-loader
      class="mx-auto"
      v-if="!faq"
      type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
    ></v-skeleton-loader>
    <v-card shaped class="elevation-10" v-else>
      <v-card-title>
        <div>รายการคำถาม</div>
        <v-spacer></v-spacer>
        <v-btn color="success" to="/faq/create">เพิ่มคำถาม</v-btn>
      </v-card-title>
      <v-card-text class="py-0">
        <v-text-field v-model="term" dense solo prepend-inner-icon="mdi-magnify" label="ค้นหา" @input="searchChange"></v-text-field>
      </v-card-text>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th style="width: 45%;">คำถาม</th>
              <th style="width: 50%;">คำตอบ</th>
              <th style="width: 5%;"></th>
            </tr>
          </thead>
          <tbody v-if="faq.length > 0">
            <tr v-for="item in faq" :key="item.id">
              <td class="text-top">{{ item.question }}</td>
              <td class="py-2 text-top">{{ item.answer }}</td>
              <td>
                <v-menu offset-y transition="fade-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-on="on" v-bind="attrs"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                  </template>
                  <v-list>
                    <v-list-item :to="`/faq/${item.id}/edit`">
                      <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
                      <v-list-item-title>แก้ไข</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="confirmDeleteForm(item.id)">
                      <v-list-item-icon><v-icon>mdi-delete</v-icon></v-list-item-icon>
                      <v-list-item-title>ลบ</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <v-subheader>---ไม่พบคำถามในระบบ---</v-subheader>
          </tbody>
        </template>
      </v-simple-table>

      <!-- <v-pagination
        class="pb-5"
        v-model="page"
        :length="faq.last_page"
        @input="selectPage"
      ></v-pagination> -->
    </v-card>
    <v-dialog v-model="confirm_delete" max-width="500">
      <v-card>
        <v-card-title>ยืนยันการลบคำถาม</v-card-title>
        <v-card-text>คุณต้องการลบคำถามนี้ใช่หรือไม่</v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="deleteForm()">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  data: () => ({
    page: 1,
    term: '',
    faq: null,
    confirm_delete: false
  }),
  created() {
    this.getFAQ('', this.page);
  },
  methods: {
    getFAQ(term, page) {
      this.$store.dispatch('faq/list', {
        term: term,
        page: page
      }).then(data => this.faq = data);
    },
    deleteForm() {
      this.$store.dispatch('faq/delete', this.delete_selected).then(() => {
        this.getFAQ('', 1);
        this.confirm_delete = false;
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: 'ลบข้อมูลสำเร็จ'
        });
      });
    },
    confirmDeleteForm(id) {
      this.confirm_delete = true;
      this.delete_selected = id;
    },
    selectPage(e) {
      this.page = e;
      this.getFAQ(this.term, e);
    },
    searchChange: _.debounce(function(e) {
      this.page = 1;
			this.getFAQ(e, 1);
		}, 500),
  }
}
</script>